import * as Models from "../.";
import {MarketAssumedValuesBase} from ".";
export class MultiInvestorPricingAssumedValues extends MarketAssumedValuesBase.MarketAssumedValuesBase {
  defaultContractSignDate?: Date;
  epcCap: number;
  termLength: number;
  percentYield: number;
  percentDegredation: number;
  productionByMonth: { [key: number]: number };
  srecFactor: number;
  srecCommissionPercent: number;
  srecMintingPeriodLength: number;
  numberOfSrecYears: number;
  srecPriceIntervals: Models.MarketAssumedValuesModel.SrecPriceInterval[];
  relativeSrecSellingMonths: number[];
  operationManagementCostPerKw: number;
  operationManagementEscalator: number;
  operationManagementFreeStartYears: number;
  insuranceRate: number;
  insuranceEscalator: number;
  annualCellServiceFee: number;
  cellServiceFreeStartYears: number;
  cellServiceEscalator: number;
  inverterReplacementCostPerWatt: number;
  inverterReserveStartYear: number;
  inverterReplacementYear: number;
  assetManagementFeePerKw: number;
  systemRemovalNetRevenuePerWatt: number;
  investmentTaxCreditPercent: number;
  taxAllocationPercent: number;
  fundingMultiplier: number;
  preflipAnnualReturnRate: number;
  preflipCommonCashSharePercent: number;
  postflipEbitdaPercent: number;
}
